import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface cartItemData {
  paymentStatus?:string
  insurerName: string
  quoteNumber: string
  insuranceNumber: number
  insuranceName: string
  premium: number
  sumInsured: number
  code: string
  insurerLogo: string
  insurerId: string
  pincode: string
  addons: {
    code: string
    name: string
    si_type: string
    si_value: string
    amount: string
    value: string
  }[]
  loading?: boolean
  addonsTotal?: string
  discountTotal?: string
  loadingTotal?: string
  netPremium?: string
  basePremium?: string
  GST?: string
  addedMemberTypes?: ('proposer' | 'son' | 'father' | 'mother' | 'daughter' | 'spouse')[]
  memberType?: 'parents' | 'selfSpouseKids' | 'allMembers'
  uniqueIdentifier?: string
  duration: number
  isAutoDebitSupported: boolean
  isAutoPaySupported: boolean
}
export type ISelectedPlanType = 'Family Floater' | 'Individual' | 'Multi Individual' | ''
export interface ICartState {
  cartDetails: {
    parents: cartItemData | null
    selfSpouseKids: cartItemData | null
    allMembers: cartItemData | null
  }
  selectedQuotes: { [key: string]: cartItemData }
  selectedPlanType: ISelectedPlanType
  requestId: string
  totalAddedMembers: ('proposer' | 'son' | 'father' | 'mother' | 'daughter' | 'spouse')[]
  sp_consent_identifier?: string
  customer_consent_identifier?: string
  cartId: string
  proposal_number:string

}

const initialState: ICartState = {
  cartDetails: {
    parents: null,
    selfSpouseKids: null,
    allMembers: null,
  },
  selectedQuotes: {},
  selectedPlanType: '',
  requestId: '',
  totalAddedMembers: [],
  sp_consent_identifier: '',
  customer_consent_identifier: '',
  cartId: '',
  proposal_number:''
}

const cartSlice = createSlice({
  name: 'cart',
  initialState: initialState,
  reducers: {
    setSPConsentIndentifier: (state, action: PayloadAction<string>) => {
      state.sp_consent_identifier = action.payload
    },
    setCustomerConsentIndentifier: (state, action: PayloadAction<string>) => {
      state.customer_consent_identifier = action.payload
    },
    resetCartDetails: () => initialState,
    addToCart: (
      state,
      action: PayloadAction<{
        memberCategory: 'parents' | 'selfSpouseKids' | 'allMembers'
        data: cartItemData
      }>,
    ) => {
      state.cartDetails[action.payload.memberCategory] = action.payload.data
    },
    removeFromCart: (
      state,
      action: PayloadAction<{
        memberCategory: 'parents' | 'selfSpouseKids' | 'allMembers'
      }>,
    ) => {
      state.cartDetails[action.payload.memberCategory] = null
    },
    clearCart: (state) => {
      state.cartDetails = {
        parents: null,
        selfSpouseKids: null,
        allMembers: null,
      }
    },
    updateSelectedQuotes: (
      state,
      action: PayloadAction<{
        key: string
        data: cartItemData
      }>,
    ) => {
      state.selectedQuotes[action.payload.key] = action.payload.data
    },
    removeSelectedQuotes: (state) => {
      state.selectedQuotes = {}
    },
    updatedPlanType: (
      state,
      action: PayloadAction<'Family Floater' | 'Individual' | 'Multi Individual' | ''>,
    ) => {
      state.selectedPlanType = action.payload
    },
    updateRequestId: (state, action: PayloadAction<string>) => {
      state.requestId = action.payload
    },
    updateCartId: (state, action: PayloadAction<string>) => {
      state.cartId = action.payload
    },
    updateProposalNumber: (state, action: PayloadAction<string>) => {
      state.proposal_number = action.payload
    },
    
    updatePaymentStatus: (state, action: PayloadAction<{key: string,paymentStatus:string}>) => {
      if(state.selectedQuotes)
      state.selectedQuotes[action.payload.key].paymentStatus = action.payload.paymentStatus
    },
    
    updateTotalMembers: (
      state,
      action: PayloadAction<('proposer' | 'son' | 'father' | 'mother' | 'daughter' | 'spouse')[]>,
    ) => {
      state.totalAddedMembers = action.payload
    },
    updateCompleteCartData: (state, action: PayloadAction<ICartState>) => {
      state.cartDetails = action.payload.cartDetails
      state.selectedQuotes = action.payload.selectedQuotes
      state.selectedPlanType = action.payload.selectedPlanType
      state.requestId = action.payload.requestId
      state.totalAddedMembers = action.payload.totalAddedMembers
      state.customer_consent_identifier = action.payload.customer_consent_identifier
      state.cartId = action.payload.cartId
      state.sp_consent_identifier =action.payload.sp_consent_identifier
    },
  },
})

const { reducer } = cartSlice

export const {
  addToCart,
  removeFromCart,
  clearCart,
  updateSelectedQuotes,
  updatedPlanType,
  removeSelectedQuotes,
  updateRequestId,
  updateTotalMembers,
  updateCompleteCartData,
  resetCartDetails,
  setSPConsentIndentifier,
  setCustomerConsentIndentifier,
  updateCartId,
  updatePaymentStatus,
  updateProposalNumber
} = cartSlice.actions

export { reducer as cartReducer }
